import client from './client'
import { buildListParams } from '../utils/pagination'

export function fetchTrips({ page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get('/api/v1/trips', { params })
}

export function fetchPublicTrips({ sort = 'new', page, perPage } = {}) {
  const params = buildListParams({ page, perPage, extra: { sort } })
  return client.get('/api/v1/public_trips', { params })
}

export function fetchUserPublicTrips(userId) {
  return client.get(`/api/v1/users/${userId}/public_trips`)
}

export function fetchUserPublicTripsByUsername(username) {
  return client.get(`/api/v1/u/${encodeURIComponent(username)}/trips`)
}

export function fetchTrip(id) {
  return client.get(`/api/v1/trips/${id}`)
}

export function createTrip(payload, photos = []) {
  const formData = new FormData()
  formData.append('trip[name]', payload.name)
  formData.append('trip[trip_date]', payload.trip_date)
  if (payload.body) formData.append('trip[body]', payload.body)
  if (payload.track_completion_id) {
    formData.append('trip[track_completion_id]', payload.track_completion_id)
  }
  formData.append('trip[public]', payload.public ? '1' : '0')
  formData.append('trip[allow_comments]', payload.allow_comments ? '1' : '0')
  if (payload.companion_user_ids?.length) {
    payload.companion_user_ids.forEach((id) => {
      formData.append('trip[companion_user_ids][]', id)
    })
  }
  photos.forEach((photo) => formData.append('photos[]', photo))
  return client.post('/api/v1/trips', formData)
}

export function updateTrip(id, payload, photos = []) {
  const formData = new FormData()
  if (payload.name !== undefined) formData.append('trip[name]', payload.name)
  if (payload.trip_date !== undefined) formData.append('trip[trip_date]', payload.trip_date)
  if (payload.body !== undefined) formData.append('trip[body]', payload.body)
  if (payload.track_completion_id !== undefined) {
    formData.append('trip[track_completion_id]', payload.track_completion_id || '')
  }
  if (payload.public !== undefined) formData.append('trip[public]', payload.public ? '1' : '0')
  if (payload.allow_comments !== undefined) {
    formData.append('trip[allow_comments]', payload.allow_comments ? '1' : '0')
  }
  if (payload.companion_user_ids !== undefined) {
    payload.companion_user_ids.forEach((companionId) => {
      formData.append('trip[companion_user_ids][]', companionId)
    })
  }
  photos.forEach((photo) => formData.append('photos[]', photo))
  return client.patch(`/api/v1/trips/${id}`, formData)
}

export function deleteTrip(id) {
  return client.delete(`/api/v1/trips/${id}`)
}

export function updateTripVisibilitySettings(tripId, isPublic) {
  return client.patch(`/api/v1/trips/${tripId}/visibility_settings`, {
    public: isPublic,
  })
}

export function uploadTripBodyImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return client.post('/api/v1/trip_body_images', formData)
}

export function searchUsers(query) {
  return client.get('/api/v1/users/search', { params: { q: query } })
}

export function favoriteTrip(tripId) {
  return client.post(`/api/v1/trips/${tripId}/favorite`)
}

export function unfavoriteTrip(tripId) {
  return client.delete(`/api/v1/trips/${tripId}/favorite`)
}

export function fetchFavoriteTrips({ page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get('/api/v1/favorites/trips', { params })
}

export function setTripReaction(tripId, value) {
  return client.put(`/api/v1/trips/${tripId}/reaction`, { value })
}

export function removeTripReaction(tripId) {
  return client.delete(`/api/v1/trips/${tripId}/reaction`)
}

export function fetchTripComments(tripId, { page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get(`/api/v1/trips/${tripId}/comments`, { params })
}

export function fetchPublicTripComments({ page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get('/api/v1/public_trip_comments', { params })
}

export function createTripComment(tripId, formData) {
  return client.post(`/api/v1/trips/${tripId}/comments`, formData)
}

export function deleteTripComment(tripId, commentId) {
  return client.delete(`/api/v1/trips/${tripId}/comments/${commentId}`)
}

export function updateTripCommentsSettings(tripId, allowComments) {
  return client.patch(`/api/v1/trips/${tripId}/comments_settings`, {
    allow_comments: allowComments,
  })
}

export function setTripCommentReaction(tripId, commentId, value) {
  return client.put(`/api/v1/trips/${tripId}/comments/${commentId}/reaction`, { value })
}

export function removeTripCommentReaction(tripId, commentId) {
  return client.delete(`/api/v1/trips/${tripId}/comments/${commentId}/reaction`)
}
